const OptionOrderType = ({ index, type = 'number', prefix = '', chartColor = '#E8634D', textColor = '#FFFFFF' }: {
  index: number;
  type?: 'number' | 'letter';
  prefix?: string;
  chartColor?: string;
  textColor?: string;
}) => {
  const optionLabel = type === 'number' ? index + 1 : String.fromCharCode(65 + index);
  const label = prefix ? `${prefix}${optionLabel}` : optionLabel;
  const minLabelWidth = `${Math.max(3, String(label).length + 1)}ch`;
  return (
    <div
      style={{ color: textColor, minWidth: minLabelWidth }}
      className='px-1 min-h-18 min-w-18 grid place-items-center rounded-full overflow-hidden bg-black/20'>
      <span className="whitespace-nowrap px-3 text-4xl font-semibold">
        {label}
      </span>
    </div>
  );
};

export default OptionOrderType;
